var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBizzAndLicenseplate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.5228 13.4512H22.1751C22.6307 13.4512 23 13.8205 23 14.2761V18.3882C23 18.8437 22.6307 19.2131 22.1751 19.2131H1.82494C1.36934 19.2131 1 18.8437 1 18.3882V14.2761C1 13.8205 1.36934 13.4512 1.82494 13.4512H6.96328",
    stroke: "white",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2627 16.9877C12.2627 17.3493 11.9695 17.6425 11.6079 17.6425C11.2463 17.6425 10.9531 17.3493 10.9531 16.9877V15.6782C10.9531 15.3166 11.2463 15.0234 11.6079 15.0234C11.9695 15.0234 12.2627 15.3166 12.2627 15.6782V16.9877Z",
    stroke: "white",
    strokeWidth: 0.6,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3369 16.9877C17.3369 17.3493 17.0437 17.6425 16.6821 17.6425C16.3205 17.6425 16.0273 17.3493 16.0273 16.9877V15.6782C16.0273 15.3166 16.3205 15.0234 16.6821 15.0234C17.0437 15.0234 17.3369 15.3166 17.3369 15.6782V16.9877Z",
    stroke: "white",
    strokeWidth: 0.6,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4267 15.6782C21.4267 16.0398 21.1336 16.333 20.772 16.333C20.4103 16.333 20.1172 16.0398 20.1172 15.6782C20.1172 15.3166 20.4103 15.0234 20.772 15.0234C21.1336 15.0234 21.4267 15.3166 21.4267 15.6782Z",
    stroke: "white",
    strokeWidth: 0.6,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4267 16.9868C21.4267 17.3484 21.1336 17.6416 20.772 17.6416C20.4103 17.6416 20.1172 17.3484 20.1172 16.9868C20.1172 16.6252 20.4103 16.332 20.772 16.332C21.1336 16.332 21.4267 16.6252 21.4267 16.9868Z",
    stroke: "white",
    strokeWidth: 0.6,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2647 15.5145C13.3374 15.2321 13.5938 15.0234 13.8989 15.0234C14.2605 15.0234 14.5537 15.3167 14.5537 15.6783C14.5537 16.0398 14.2605 16.333 13.8989 16.333C13.5372 16.333 13.2441 16.6262 13.2441 16.9877V17.6425H14.5537",
    stroke: "white",
    strokeWidth: 0.6,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.82469 16.333C9.18629 16.333 9.47945 16.6261 9.47945 16.9877C9.47945 17.3493 9.18629 17.6425 8.82469 17.6425H8.16992V15.0234H8.82469C9.18629 15.0234 9.47945 15.3166 9.47945 15.6782C9.47945 16.0398 9.18629 16.333 8.82469 16.333H8.16992",
    stroke: "white",
    strokeWidth: 0.6,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.6782 16.333C7.0398 16.333 7.33296 16.6261 7.33296 16.9877C7.33296 17.3493 7.0398 17.6425 6.6782 17.6425H6.02344V15.0234H6.6782C7.0398 15.0234 7.33296 15.3166 7.33296 15.6782C7.33296 16.0398 7.0398 16.333 6.6782 16.333H6.02344",
    stroke: "white",
    strokeWidth: 0.6,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3184 15.5145L18.8095 15.0234V17.6425",
    stroke: "white",
    strokeWidth: 0.6,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3184 17.6406H19.3005",
    stroke: "white",
    strokeWidth: 0.6,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.14258 13.4512V19.2131",
    stroke: "white",
    strokeWidth: 0.6,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4207 10.6086C19.4843 11.1768 19.1238 11.7057 18.5715 11.8532C17.5239 12.1329 15.6762 12.5985 13.3975 13.055C11.121 13.5112 9.23803 13.7932 8.163 13.9388C7.59856 14.0152 7.06329 13.669 6.90143 13.1229C6.66677 12.331 6.34514 11.1853 6.16396 10.2806C5.98168 9.37108 5.83379 8.1683 5.74317 7.33551C5.68154 6.76868 6.04203 6.2422 6.5929 6.09513C7.64128 5.81529 9.48695 5.35038 11.7624 4.89449C14.0401 4.43814 15.9239 4.15604 16.9987 4.01054C17.5651 3.93383 18.102 4.2828 18.2618 4.83152C18.4688 5.54257 18.7494 6.58553 18.9754 7.71387C19.1996 8.83307 19.3397 9.88389 19.4207 10.6086H19.4207Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1469 7.62862C15.9776 7.86287 14.8397 7.10492 14.6055 5.93555",
    stroke: "white",
    strokeWidth: 0.7,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.413 8.95239C15.5129 9.33309 13.6639 8.10138 13.2832 6.20117",
    stroke: "white",
    strokeWidth: 0.7,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6792 10.2742C15.0482 10.8014 12.4881 9.09582 11.9609 6.46484",
    stroke: "white",
    strokeWidth: 0.7,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBizzAndLicenseplate);
export default __webpack_public_path__ + "static/media/bizzAndLicenseplate.e4ea7b221668ae1594fe0de7af75d7c2.svg";
export { ForwardRef as ReactComponent };